import { render, staticRenderFns } from "./LegalRepresentative.vue?vue&type=template&id=b2e91530"
import script from "./LegalRepresentative.vue?vue&type=script&lang=js"
export * from "./LegalRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports